"use client";

import { AtomComponents } from "../atoms"
import { BlocksComponents } from "../blocks"

const components: {
  [type: string]: any
} = {
  ...AtomComponents,
  ...BlocksComponents,
}

interface SanityContentProps {
  content: any
}

const SanityContent = ({ content }: SanityContentProps) => {
  const Component = components[content._type]

  if (!Component) {
    console.error("Cannot render component type", content._type, content)
    return <></>
  }

  return <Component content={content} />
}

interface SanityContentsProps {
  contents: any[]
}

export const SanityContents = ({ contents }: SanityContentsProps) => {
  return (
    <>
      {contents
        ?.filter((x) => !x.options?.hidden)
        .map((x) => <SanityContent key={x._key} content={x} />)}
    </>
  )
}
